define('Store.Selector.EntryPoint', [
    'Store.Selector.View',
    'underscore'
], function StoreSelectorEntryPoint(
    View,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var layout = application.getComponent('Layout');
            layout.addChildViews('Backbone.View', {
                'Store.Selector': {
                    'Store.Selector': {
                        childViewIndex: 1,
                        childViewConstructor: function childViewConstructor() {
                            return new View({
                                application: application
                            });
                        }
                    }
                }
            });

            application.openStoreDropdown = function openStoreDropdown() {
                _.defer(function fnDefer() {
                    application.getLayout().$('#store-finder-container').dropdown('toggle');
                });
            };
        }
    };
});
